import axios from "axios";

import { IGetPendingBookingTotalParams, ITotalPendingBookingsBySegmentAndCategory } from "../../pages/dashboard/types";

export const getTotalPendingBookingsBySegmentAndCategory = async (params: IGetPendingBookingTotalParams): Promise<ITotalPendingBookingsBySegmentAndCategory> => {
    const response = await axios.post('/booking/dashboard/total/bySegments', params);
    return response.data;
};
